module.exports = __webpack_public_path__ + "static/media/playspace_section4.cdb0bc05.png";